

const container = document.querySelector('body');



container.addEventListener('click', function(event) {

    const changeImageElement = event.target.closest('.change-image');
    if(changeImageElement) {
        updateProductCardImage(changeImageElement);

    }
});
function updateProductCardImage(changeImageElement) {
    const optionValue = changeImageElement.getAttribute('data-option-value');
    const optionNumber = changeImageElement.getAttribute('data-option');
    const card = changeImageElement.closest('.spf-product-card');
    const obj = scriptLoad(card);
    const { image: { src }} = filterMyVariant(obj, optionValue, optionNumber);
    changeImage(card, src);
}


function changeImage (card, src) {
    if(!src) return;

    const firstImage = card.querySelector('.spf-product-card__image:first-child');
    firstImage.src = src;
    firstImage.srcset = src;
}


function filterMyVariant(arr,value, optionNumber) {
    let variant = arr.find(variant => variant[`option${optionNumber}`] === value);
    variant && variant.image && variant.image.src ? variant = variant : variant = { image: { src: false } };

    return variant;
}

function scriptLoad (card) {
    const script = card.querySelector('script[type="application/json"]');
    
    return JSON.parse(script.textContent);
}